export default "assets/images/team-forms-bg-46afd803.svg";